import { Component, input } from '@angular/core';
import { NaturalLanguageEditorKeyphraseAbstractDirective } from '../natural-language-editor-keyphrase.abstract.directive';

export type NaturalLanguageSingleOption = {
  label: string;
  value: string;
};

@Component({
  selector: 'ziro-natural-language-editor-single',
  templateUrl: 'natural-language-editor-single.component.html',
  styleUrls: ['../natural-language-editor-keyphrase.component.scss'],
  providers: [
    { provide: NaturalLanguageEditorKeyphraseAbstractDirective, useExisting: NaturalLanguageEditorSingleComponent },
  ],
  standalone: false,
})
export class NaturalLanguageEditorSingleComponent extends NaturalLanguageEditorKeyphraseAbstractDirective<string> {
  readonly options = input<NaturalLanguageSingleOption[]>();
}
